import styled from 'styled-components';

interface PageLayoutProps {
  'gomo-theme-background'?: boolean;
}

const PageLayout = styled.div<PageLayoutProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  
  @media (max-width: 768px) {
    ${props => props['gomo-theme-background'] && `
      background-color: white;
    `}
  }
`;

export default PageLayout;
